/* istanbul ignore file */
import { TableNoLeftRightBorders } from 'components/base/layout-components';
import LoadingTable from '../../../ResourceAllocationOverview/JiraStats/LoadingTable';
import Header from './Header';
import { StyledProgressionTable } from './ProgressionTable.style';
import useTableLayout from './useProgressionTable/table-layouts/useTableLayout';
import useProgressionTable from './useProgressionTable/useProgressionTable';
import Table from 'components/base/Table';
import EmptyStateAdjustFilters from '../empty-state/EmptyStateAdjustFilters';
import ProgressionTableContextProvider from './context/ProgressionTableContextProvider';

const ProgressionTable = () => {
  const {
    data,
    isLoading,
    tableType,
    setTableType,
    stateTypes,
    onClickStateType,
    keyword,
    setKeyword,
    pagination,
    tableSortBy,
    filtersBarHeight
  } = useProgressionTable();
  const { rows = [], cols = [] } = useTableLayout({ data, tableType });

  const isDataExists = (data?.data || []).length > 0;

  return (
    <ProgressionTableContextProvider tableType={tableType}>
      <StyledProgressionTable offset={filtersBarHeight}>
        <Header
          tableType={tableType}
          setTableType={setTableType}
          keyword={keyword}
          setKeyword={setKeyword}
          stateTypes={stateTypes}
          onClickStateType={onClickStateType}
          data={data}
          isLoading={isLoading}
        />
        {isLoading ? (
          <LoadingTable
            cols={[1, 2, 3, 4, 5, 6]}
            rowsNumber={pagination.pageSize}
          />
        ) : isDataExists ? (
          <TableNoLeftRightBorders>
            <Table
              data={rows}
              columns={cols}
              withPagination
              totalRows={pagination.total}
              rowsPerPage={pagination.pageSize}
              rowsPerPageOptions={25}
              onChangeRowsPerPage={event =>
                pagination.setPageSize(event.target.value)
              }
              onChangePage={(event, nextPage) =>
                pagination.setPage(nextPage + 1)
              }
              page={isDataExists ? pagination.page - 1 : 0}
              sortBy={tableSortBy.key}
              sortOrder={tableSortBy.dir}
              onSort={tableSortBy.onChange}
              withStickyHeader={false}
            />
          </TableNoLeftRightBorders>
        ) : (
          <EmptyStateAdjustFilters />
        )}
      </StyledProgressionTable>
    </ProgressionTableContextProvider>
  );
};

export default ProgressionTable;
